import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"


import globalMU from "globalMU"

export type DefinirIdPontoRetiradaItemParams = {
    identificadorItem: number,
    idPontoRetiradaItem: number,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirIdPontoRetiradaItem(params: DefinirIdPontoRetiradaItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirIdPontoRetiradaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem,
            params.idPontoRetiradaItem,
        )

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

    } finally {
        globalMU.unblockUI()
    }
}